import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("svss_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("svss_cart", JSON.stringify(items)); }, [items]);

  const addProduct = (product, quantity = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.kind === "product" && i.ref_id === product.id);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + quantity };
        return copy;
      }
      return [...prev, { kind: "product", ref_id: product.id, name: product.name, image: product.image_url, unit_price: product.price, quantity }];
    });
    setOpen(true);
  };

  const addBook = (book, duration) => {
    setItems((prev) => {
      if (prev.some((i) => i.kind === "book" && i.ref_id === book.id)) return prev;
      return [...prev, { kind: "book", ref_id: book.id, name: book.title, image: book.cover_url, duration_id: duration.id, duration_label: duration.label, days: duration.days, unit_price: duration.price, quantity: 1 }];
    });
    setOpen(true);
  };

  const remove = (idx) => setItems((prev) => prev.filter((_, i) => i !== idx));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + i.unit_price * i.quantity, 0);

  return <CartContext.Provider value={{ items, addProduct, addBook, remove, clear, subtotal, open, setOpen }}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
